import { createElement, forwardRef } from "react";
import styles from "./NavListItem.module.css";

function ChevronTrailing() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        d="M10 7l5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Text row + trailing chevron from Figma "Nav List" (node 493:15055).
 * Figma `Property 1`: Default (midnight), Tap (brand secondary + 16px gap — modeled as :hover/:active),
 * Selected (midnight + bottom border, 8px gap).
 *
 * Distinct from icon-only `NavItem` (Figma Nav Items, 346:4525).
 */
const NavListItem = forwardRef(function NavListItem(
  {
    label,
    selected = false,
    icon,
    as,
    className,
    disabled = false,
    type = "button",
    ...rest
  },
  ref,
) {
  const Tag = as ?? "button";
  const isNativeButton = typeof Tag === "string" && Tag === "button";

  const rootClass = [
    styles.root,
    selected && styles.selected,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const iconNode =
    icon == null
      ? <ChevronTrailing />
      : typeof icon === "function"
        ? createElement(icon)
        : icon;

  const props = {
    ...rest,
    ref,
    className: rootClass,
  };

  if (isNativeButton) {
    props.type = rest.type ?? type;
    props.disabled = disabled;
  } else if (disabled) {
    props["aria-disabled"] = true;
    props.tabIndex = -1;
  }

  return createElement(
    Tag,
    props,
    <span className={styles.label}>{label}</span>,
    <span className={styles.icon}>{iconNode}</span>,
  );
});

export default NavListItem;
